(function () {
  'use strict';

  if (window.__macamoreDeliveryDateV3) return;
  window.__macamoreDeliveryDateV3 = true;

  var PICKER = '[data-delivery-date-picker]';
  var INPUT = '[data-delivery-date-input]';
  var TRIGGER = '[data-delivery-date-trigger]';
  var DISPLAY = '[data-delivery-date-display]';
  var PORTAL_ID = 'macamore-calendar-portal';
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var WEEKDAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var activePicker = null;
  var viewDate = null;
  var observerTimer = null;

  function pad(value) { return String(value).padStart(2, '0'); }

  function toKey(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function fromKey(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
    if (!match) return null;
    var date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12, 0, 0, 0);
    if (date.getFullYear() !== Number(match[1]) || date.getMonth() !== Number(match[2]) - 1 || date.getDate() !== Number(match[3])) return null;
    return date;
  }

  function normaliseDateToken(token) {
    token = String(token || '').trim();
    if (!token) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(token)) return fromKey(token) ? token : '';
    var match = /^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{4})$/.exec(token);
    if (!match) return '';
    var key = match[3] + '-' + pad(match[2]) + '-' + pad(match[1]);
    return fromKey(key) ? key : '';
  }

  function parseRules(raw) {
    var singles = Object.create(null);
    var ranges = [];
    String(raw || '').split(/\r?\n|,/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var parts = line.split(/\s+(?:to|through|until)\s+|\s*\.\.\s*/i);
      if (parts.length >= 2) {
        var start = normaliseDateToken(parts[0]);
        var end = normaliseDateToken(parts[1]);
        if (start && end) {
          if (start > end) { var swap = start; start = end; end = swap; }
          ranges.push({ start: start, end: end });
        }
        return;
      }
      var single = normaliseDateToken(line);
      if (single) singles[single] = true;
    });
    return { singles: singles, ranges: ranges };
  }

  function isBlackout(key, rules) {
    if (!key || !rules) return false;
    if (rules.singles[key]) return true;
    return rules.ranges.some(function (range) { return key >= range.start && key <= range.end; });
  }

  function getMinDays(picker) {
    var value = parseInt(picker && picker.dataset ? picker.dataset.minDays : '2', 10);
    return Number.isFinite(value) && value >= 0 ? value : 2;
  }

  function getMinimumDate(picker) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + getMinDays(picker));
    return date;
  }

  function getRules(picker) { return parseRules(picker && picker.dataset ? picker.dataset.blackoutRules : ''); }

  function isAllowed(picker, key) {
    if (!picker || !fromKey(key)) return false;
    return key >= toKey(getMinimumDate(picker)) && !isBlackout(key, getRules(picker));
  }

  function formatDisplay(key) {
    var date = fromKey(key);
    if (!date) return 'Select date';
    return pad(date.getDate()) + ' ' + MONTHS[date.getMonth()].slice(0, 3) + ' ' + date.getFullYear();
  }

  function getInput(picker) { return picker ? picker.querySelector(INPUT) : null; }
  function getTrigger(picker) { return picker ? picker.querySelector(TRIGGER) : null; }
  function getDisplay(picker) { return picker ? picker.querySelector(DISPLAY) : null; }
  function getError(picker) { return picker ? picker.querySelector('.macamore-date-error') : null; }

  function setError(picker, message) {
    var error = getError(picker);
    var input = getInput(picker);
    var trigger = getTrigger(picker);
    if (error) { error.textContent = message || ''; error.hidden = !message; }
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (trigger) trigger.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function validationMessage(picker, value) {
    if (!value) return 'Please select a delivery date before checkout.';
    if (value < toKey(getMinimumDate(picker))) return 'Please select a delivery date at least ' + getMinDays(picker) + ' days from today.';
    if (isBlackout(value, getRules(picker))) return 'That delivery date is unavailable. Please choose another date.';
    return 'Please choose a valid delivery date.';
  }

  function validatePicker(picker, showMessage) {
    if (!picker) return true;
    var input = getInput(picker);
    if (!input) return true;
    var minKey = toKey(getMinimumDate(picker));
    input.min = minKey;
    input.required = true;
    var valid = isAllowed(picker, input.value);
    var message = !valid && showMessage ? validationMessage(picker, input.value) : '';
    setError(picker, message);
    input.setCustomValidity(message);
    syncCheckoutState();
    return valid;
  }

  function syncCheckoutState() {
    var picker = document.querySelector('#cart-drawer ' + PICKER) || document.querySelector(PICKER);
    var valid = picker ? isAllowed(picker, (getInput(picker) || {}).value) : true;
    var summary = picker ? picker.closest('.cart-drawer__summary') : document.querySelector('.cart-drawer__summary');
    if (!summary) return valid;
    var accelerated = summary.querySelector('.additional-checkout-buttons');
    if (accelerated) {
      accelerated.classList.toggle('delivery-date-locked', !valid);
      accelerated.setAttribute('aria-disabled', valid ? 'false' : 'true');
    }
    return valid;
  }

  async function saveAttribute(value) {
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery Date': value || '' } })
      });
    } catch (error) {
      console.warn('[delivery-date] Could not save cart attribute:', error);
    }
  }

  function enhancePicker(picker) {
    if (!picker) return;
    var input = getInput(picker);
    var trigger = getTrigger(picker);
    var display = getDisplay(picker);
    if (!input || !trigger || !display) return;

    input.min = toKey(getMinimumDate(picker));
    input.required = true;

    if (input.value && !isAllowed(picker, input.value)) {
      input.value = '';
      saveAttribute('');
    }

    display.textContent = formatDisplay(input.value);
    trigger.hidden = false;
    picker.classList.add('is-enhanced');
    validatePicker(picker, false);
  }

  function enhanceAll() {
    document.querySelectorAll(PICKER).forEach(enhancePicker);
  }

  function getPortalHost(picker) {
    return (picker && picker.closest('#cart-drawer dialog')) || document.querySelector('#cart-drawer dialog') || document.body;
  }

  function ensurePortal(picker) {
    var portal = document.getElementById(PORTAL_ID);
    var host = getPortalHost(picker);
    if (portal && portal.parentElement !== host) host.appendChild(portal);
    if (portal) return portal;

    portal = document.createElement('div');
    portal.id = PORTAL_ID;
    portal.className = 'macamore-calendar-portal';
    portal.hidden = true;
    portal.innerHTML = '<div class="macamore-calendar-panel" role="dialog" aria-modal="true" aria-label="Choose delivery date" data-calendar-panel></div>';
    host.appendChild(portal);
    return portal;
  }

  function closeCalendar(restoreFocus) {
    var portal = document.getElementById(PORTAL_ID);
    if (portal) portal.hidden = true;
    if (activePicker) {
      var trigger = getTrigger(activePicker);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus({ preventScroll: true });
      }
    }
    activePicker = null;
  }

  function openCalendar(picker) {
    if (!picker) return;
    enhancePicker(picker);
    activePicker = picker;
    var input = getInput(picker);
    var selected = input && fromKey(input.value);
    var minimum = getMinimumDate(picker);
    var base = selected || minimum;
    viewDate = new Date(base.getFullYear(), base.getMonth(), 1, 12, 0, 0, 0);
    var portal = ensurePortal(picker);
    renderCalendar();
    portal.hidden = false;
    var trigger = getTrigger(picker);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function renderCalendar() {
    if (!activePicker || !viewDate) return;
    var portal = ensurePortal(activePicker);
    var panel = portal.querySelector('[data-calendar-panel]');
    if (!panel) return;

    var input = getInput(activePicker);
    var selectedKey = input ? input.value : '';
    var minKey = toKey(getMinimumDate(activePicker));
    var rules = getRules(activePicker);
    var todayKey = toKey(new Date());
    var year = viewDate.getFullYear();
    var month = viewDate.getMonth();
    var first = new Date(year, month, 1, 12, 0, 0, 0);
    var count = new Date(year, month + 1, 0, 12, 0, 0, 0).getDate();
    var minDate = getMinimumDate(activePicker);
    var atMinMonth = year === minDate.getFullYear() && month === minDate.getMonth();
    var beforeMinMonth = year < minDate.getFullYear() || (year === minDate.getFullYear() && month < minDate.getMonth());

    if (beforeMinMonth) {
      viewDate = new Date(minDate.getFullYear(), minDate.getMonth(), 1, 12, 0, 0, 0);
      return renderCalendar();
    }

    var html = '';
    html += '<div class="macamore-calendar__header">';
    html += '<button type="button" class="macamore-calendar__nav" data-calendar-nav="-1" aria-label="Previous month"' + (atMinMonth ? ' disabled' : '') + '>‹</button>';
    html += '<p class="macamore-calendar__title" aria-live="polite">' + MONTHS[month] + ' ' + year + '</p>';
    html += '<button type="button" class="macamore-calendar__nav" data-calendar-nav="1" aria-label="Next month">›</button>';
    html += '</div>';
    html += '<div class="macamore-calendar__weekdays" aria-hidden="true">';
    WEEKDAYS.forEach(function (day) { html += '<div class="macamore-calendar__weekday">' + day + '</div>'; });
    html += '</div><div class="macamore-calendar__days">';
    for (var blank = 0; blank < first.getDay(); blank += 1) html += '<div class="macamore-calendar__blank" aria-hidden="true"></div>';
    for (var day = 1; day <= count; day += 1) {
      var date = new Date(year, month, day, 12, 0, 0, 0);
      var key = toKey(date);
      var blackout = isBlackout(key, rules);
      var tooSoon = key < minKey;
      var disabled = blackout || tooSoon;
      var classes = ['macamore-calendar__day'];
      if (blackout) classes.push('is-blackout');
      if (key === selectedKey) classes.push('is-selected');
      if (key === todayKey) classes.push('is-today');
      var label = day + ' ' + MONTHS[month] + ' ' + year + (blackout ? ', unavailable' : '') + (tooSoon ? ', too soon' : '');
      html += '<button type="button" class="' + classes.join(' ') + '" data-calendar-date="' + key + '" aria-label="' + label + '"' + (disabled ? ' disabled' : '') + '>' + day + '</button>';
    }
    html += '</div>';
    html += '<div class="macamore-calendar__legend"><span class="macamore-calendar__legend-swatch" aria-hidden="true"></span> Grey dates are unavailable</div>';
    html += '<div class="macamore-calendar__actions"><button type="button" class="macamore-calendar__close" data-calendar-close>Close</button></div>';
    panel.innerHTML = html;
  }

  function selectDate(key) {
    if (!activePicker || !isAllowed(activePicker, key)) return;
    var picker = activePicker;
    var input = getInput(picker);
    var display = getDisplay(picker);
    if (!input) return;
    input.value = key;
    if (display) display.textContent = formatDisplay(key);
    validatePicker(picker, false);
    saveAttribute(key);
    closeCalendar(true);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest(TRIGGER);
    if (trigger) {
      var picker = trigger.closest(PICKER);
      if (!picker) return;
      event.preventDefault();
      var portal = document.getElementById(PORTAL_ID);
      if (activePicker === picker && portal && !portal.hidden) closeCalendar(false);
      else openCalendar(picker);
      return;
    }

    var nav = event.target.closest('[data-calendar-nav]');
    if (nav && activePicker) {
      event.preventDefault();
      if (!nav.disabled) {
        viewDate = new Date(viewDate.getFullYear(), viewDate.getMonth() + Number(nav.dataset.calendarNav || 0), 1, 12, 0, 0, 0);
        renderCalendar();
      }
      return;
    }

    var day = event.target.closest('[data-calendar-date]');
    if (day && activePicker) {
      event.preventDefault();
      if (!day.disabled) selectDate(day.dataset.calendarDate);
      return;
    }

    if (event.target.closest('[data-calendar-close]')) {
      event.preventDefault();
      closeCalendar(true);
      return;
    }

    var portal = event.target.closest('#' + PORTAL_ID);
    if (portal && event.target === portal) {
      closeCalendar(true);
      return;
    }
  });

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches(INPUT)) return;
    var picker = event.target.closest(PICKER);
    if (!picker) return;
    if (!validatePicker(picker, true)) {
      event.target.value = '';
      var display = getDisplay(picker);
      if (display) display.textContent = 'Select date';
      return;
    }
    var display = getDisplay(picker);
    if (display) display.textContent = formatDisplay(event.target.value);
    saveAttribute(event.target.value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activePicker) closeCalendar(true);
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var target = event.target.closest('button[name="checkout"], .additional-checkout-buttons');
    if (!target || !target.closest('.cart-drawer__summary')) return;
    var picker = document.querySelector('#cart-drawer ' + PICKER);
    if (!picker || validatePicker(picker, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var trigger = getTrigger(picker);
    if (trigger && !trigger.hidden) trigger.focus({ preventScroll: false });
    else {
      var input = getInput(picker);
      if (input) { input.focus({ preventScroll: false }); input.reportValidity(); }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!(event.target instanceof HTMLFormElement) || event.target.id !== 'cart-form') return;
    var picker = document.querySelector('#cart-drawer ' + PICKER);
    if (!picker || validatePicker(picker, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var trigger = getTrigger(picker);
    if (trigger && !trigger.hidden) trigger.focus({ preventScroll: false });
  }, true);

  function scheduleEnhance() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(function () {
      enhanceAll();
      if (activePicker && !document.documentElement.contains(activePicker)) closeCalendar(false);
    }, 30);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  else enhanceAll();

  document.addEventListener('shopify:section:load', enhanceAll);
  document.addEventListener('shopify:cart:lines-update', function () { requestAnimationFrame(enhanceAll); });
  new MutationObserver(scheduleEnhance).observe(document.documentElement, { childList: true, subtree: true });
})();
